import {defineStore} from 'pinia'
import {readonly, ref, watch} from "vue";

export const HProgressorStore = defineStore('HProgressorStore', () => {
    const privateStepData = ref(new Map());
    const stepData = readonly(privateStepData);
    const registeredComponentIDs = ref([]);


    function setStepData (stepID, stepData) {
        if (registeredComponentIDs.value.length === 0) throw new Error("Interner Fehler: keine registrierten Komponenten gefunden. Sicherstellen, dass in HProgressor die Store-Methode registerComponentIDs() aufgerufen wird.");
        if (!registeredComponentIDs.value.includes(stepID)) {
            throw new Error("Unbekannte Step-ID: " + JSON.stringify(stepID) + ". Diese ID wird nicht von einer registrierten Komponente verwendet.");
        }
        privateStepData.value.set(stepID, stepData);
    }

    function deleteStepData (stepID) {
        privateStepData.value.delete(stepID);
    }

    function registerComponentIDs(componentIDs) {
        if (registeredComponentIDs.value.length > 0) return; // Singleton. Komponenten werden nur 1x initial registriert; ein Hinzufügen von Schritten "on the fly" ist explizit nicht vorgesehen.
        registeredComponentIDs.value = componentIDs;
    }

    function $reset() {
        privateStepData.value = new Map();
        registeredComponentIDs.value = [];
    }

    return  {stepData, setStepData, deleteStepData, registerComponentIDs, $reset}
})